import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    ", ";\n    ", ";\n\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n    border-left-width: 1px;\n    border-left-style: solid;\n    border-left-color: transparent;\n    display: flex;\n    height: calc(100% - 16px);\n    justify-content: center;\n    transition: border-color ", "s;\n    width: 100%;\n\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    outline: none;\n\n    ", "\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n              border-left-color: ", ";\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n              cursor: not-allowed;\n              color: ", ";\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n              cursor: not-allowed;\n          "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { ArrowDownIcon } from '@deliveryhero/armor-icons';
import { marginAttributes } from '../../system/attributes';
import { transitionDurationInSec } from '../../constants';
import { getPropsBlocker } from '../../utils';
import { color } from '../../system/mixins';
import { transition } from '../../system/mixins/transition';
import { expansion } from '../../system/mixins/expansion';
var propertyList = {
  disabled: true,
  displaySeparator: true,
  expanded: true
};

var expansionIndicatorContainerStyle = function expansionIndicatorContainerStyle(_ref) {
  var disabled = _ref.disabled;
  return disabled ? css(_templateObject()) : {};
};

var expansionIndicatorStyle = function expansionIndicatorStyle(_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? css(_templateObject2(), color('neutral.04')) : {};
};

var actionSeparator = function actionSeparator(_ref3) {
  var displaySeparator = _ref3.displaySeparator;
  return displaySeparator ? css(_templateObject3(), color('neutral.03')) : {};
};

export var ExpansionIndicatorRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject4(), expansionIndicatorContainerStyle, marginAttributes);
export var ExpansionIndicatorContent = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject5(), transitionDurationInSec, actionSeparator);
export var ExpansionIndicatorIcon = styled(ArrowDownIcon).withConfig(getPropsBlocker(propertyList, false))(_templateObject6(), color('primary.main'), transition({
  transform: true
}), expansion(180), expansionIndicatorStyle);